<script setup>
import { IMG } from '@/assets';
</script>

<template>
  <div class="salesforce-error">
    <img :src="IMG.emptyWave" title="Error connecting to Dash Social" />
    <h3>Dash Social Account Setup Required</h3>
    <p>
      To access Dash Social within Salesforce, you need a Dash Social account that matches your
      Salesforce login email. Please contact your Dash Social admin to set up your account.
    </p>
  </div>
</template>

<style lang="postcss" scoped>
.salesforce-error {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  max-width: 100%;
  margin: 0;
  padding: var(--space-64);

  h3 {
    margin: var(--space-40) 0 var(--space-24);
    text-transform: none;
  }

  p {
    font-size: var(--x16);
    line-height: var(--space-24);
    margin-bottom: var(--space-32);
    max-width: 480px;
  }

  img {
    height: 160px;
    width: 160px;
  }
}
</style>
